import React from 'react';
import './Header.css';

export default function Header() {
  return (
    <header className="header">
      <div className="header-inner">
        <div className="logo">
          <div className="logo-icon-wrap">
            <span className="logo-icon">✉</span>
          </div>
          <div>
            <div className="logo-text">VerifyEmails</div>
            <div className="logo-sub">Email Verification & List Cleaning</div>
          </div>
        </div>
        <div className="header-badges">
          <span className="hbadge">Syntax</span>
          <span className="hbadge">DNS/MX</span>
          <span className="hbadge">SPF/DMARC</span>
          <span className="hbadge">Disposable</span>
          <span className="hbadge">SMTP</span>
          <span className="hbadge">Catch-all</span>
        </div>
      </div>
    </header>
  );
}
